/**
 * fehlerlauscher, die zwei Fensterlauscher, und der Nachlauf der Warteschlange.
 *
 * @description
 *   Wird als ERSTER Import von `index.js` geladen. Ein Fehler beim Auswerten
 *   eines spaeteren Moduls (etwa `App.js`) passiert damit NACH der Registrierung
 *   und landet in `client_fehler`.
 *
 *   🔴 `error` feuert im Browser auch fuer fehlgeschlagene RESSOURCEN (ein Bild,
 *   ein Skript). Diese Ereignisse tragen keine `message`, sie werden hier
 *   verworfen, sonst fuellte jeder 404 eines Bildes die Tabelle.
 *
 *   Beim Laden wird ausserdem gesendet, was liegen geblieben ist: der
 *   Chunk-Pfad reiht nur ein und laedt neu, und ein Fehler zwischen Lauscher und
 *   Token hat noch keinen Token. Beides holt dieser Nachlauf nach.
 *
 * @useWhen
 *   - Genau einmal, als erster Import von `index.js`
 *
 * @dontUseFor
 *   - Als Modul, das irgendwo sonst importiert wird, es haengt globale Lauscher
 *
 * @related
 *   - `fehlerbericht.js`, der Melder und die Warteschlange
 */
import { meldeFehler, sendeWarteschlange } from './fehlerbericht';

window.addEventListener('error', (ereignis) => {
  if (!ereignis || typeof ereignis.message !== 'string' || !ereignis.message) return;
  meldeFehler({ art: 'onerror', fehler: ereignis.error || ereignis.message });
});

window.addEventListener('unhandledrejection', (ereignis) => {
  meldeFehler({ art: 'rejection', fehler: ereignis?.reason });
});

// Nach dem Laden: was liegen blieb, geht jetzt hinaus (Chunk-Pfad, Fehler vor
// dem Token). `setTimeout 0`, damit der erste Render nicht darauf wartet.
setTimeout(() => { sendeWarteschlange(); }, 0);
